"use strict";
/*
 * Created on 10 04 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var AICleaningInfoConverter_1 = require("./conversions/AICleaningInfoConverter");

var AICleaningInfoConverterImpl_1 = require("./conversions/AICleaningInfoConverterImpl");

var CategoryCleaningStateConverter_1 = require("./conversions/CategoryCleaningStateConverter");

var CategoryCleaningStateConverterImpl_1 = require("./conversions/CategoryCleaningStateConverterImpl");

var AgencyQualityEvaluationDTOConverter_1 = require("./conversions/dto/AgencyQualityEvaluationDTOConverter");

var AgencyQualityEvaluationDTOConverterIml_1 = require("./conversions/dto/AgencyQualityEvaluationDTOConverterIml");

var CompetitorPriceHistoryIndexDTOConverter_1 = require("./conversions/dto/CompetitorPriceHistoryIndexDTOConverter");

var CompetitorPriceHistoryIndexDTOConverterImpl_1 = require("./conversions/dto/CompetitorPriceHistoryIndexDTOConverterImpl");

var CRPDTOConverter_1 = require("./conversions/dto/CRPDTOConverter");

var CRPDTOConverterImpl_1 = require("./conversions/dto/CRPDTOConverterImpl");

var InternalProductPricesDTOConverter_1 = require("./conversions/dto/InternalProductPricesDTOConverter");

var InternalProductPricesDTOConverterImpl_1 = require("./conversions/dto/InternalProductPricesDTOConverterImpl");

var PriceZoneProductPriceConverter_1 = require("./conversions/dto/PriceZoneProductPriceConverter");

var PriceZoneProductPriceConverterImpl_1 = require("./conversions/dto/PriceZoneProductPriceConverterImpl");

var ProductSizesDTOConverter_1 = require("./conversions/dto/ProductSizesDTOConverter");

var ProductSizesDTOConverterImpl_1 = require("./conversions/dto/ProductSizesDTOConverterImpl");
/**
 * @author Jaroslav Sevcik
 */


var CleaningAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(CleaningAppModule, _AppModule_1$AppModul);

  function CleaningAppModule() {
    var _this;

    _classCallCheck(this, CleaningAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CleaningAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'cleaning';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CleaningAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(CategoryCleaningStateConverter_1.CategoryCleaningStateConverter).to(CategoryCleaningStateConverterImpl_1.CategoryCleaningStateConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(AICleaningInfoConverter_1.AICleaningInfoConverter).to(AICleaningInfoConverterImpl_1.AICleaningInfoConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CRPDTOConverter_1.CRPDTOConverter).to(CRPDTOConverterImpl_1.CRPDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CompetitorPriceHistoryIndexDTOConverter_1.CompetitorPriceHistoryIndexDTOConverter).to(CompetitorPriceHistoryIndexDTOConverterImpl_1.CompetitorPriceHistoryIndexDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductSizesDTOConverter_1.ProductSizesDTOConverter).to(ProductSizesDTOConverterImpl_1.ProductSizesDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(InternalProductPricesDTOConverter_1.InternalProductPricesDTOConverter).to(InternalProductPricesDTOConverterImpl_1.InternalProductPricesDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceZoneProductPriceConverter_1.PriceZoneProductPriceConverter).to(PriceZoneProductPriceConverterImpl_1.PriceZoneProductPriceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(AgencyQualityEvaluationDTOConverter_1.AgencyQualityEvaluationDTOConverter).to(AgencyQualityEvaluationDTOConverterIml_1.AgencyQualityEvaluationDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return CleaningAppModule;
}(AppModule_1.AppModule);

exports.CleaningAppModule = CleaningAppModule;